/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../../lib/feathers';

interface UserState {
  auth: { user: Record<string, any> };
  userGroup: {
    [key: string]: any;
  };
  adminUserGroup: {
    [key: string]: any;
  };
  loading: string;
  hasNewMessage: boolean;
}

export const initialState: UserState = {
  auth: { user: { householdNumbers: [''], _id: '' } },
  userGroup: {},
  adminUserGroup: {},
  loading: 'idle',
  hasNewMessage: false,
};

// 創造從database抓取現在使用者的資料的非同步action
export const fetchUser = createAsyncThunk('user/fetchUser', async () => {
  const fetchData: any[] = [];
  try {
    if (window.localStorage['feathers-jwt']) {
      const authData = await client.authenticate({
        strategy: 'jwt',
        accessToken: window.localStorage['feathers-jwt'],
      });
      fetchData.push(authData);
      const userGroup = await client
        .service('userGroup')
        .find({ query: { name: authData.user.auth } });
      console.log({ userGroup });
      fetchData.push(userGroup);
      return fetchData;
    }
    return fetchData;
  } catch (error) {
    console.error('fetchUser error', error);
    return fetchData;
  }
});

// 抓取admin UserGroup頁面權限
export const fetchAdmin = createAsyncThunk('user/fetchAdmin', async () => {
  const fetchData: any[] = [];
  const userGroup = await client
    .service('userGroup')
    .find({ query: { order: 1 } });
  fetchData.push(userGroup);
  return fetchData;
});

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    getNewMessage: (state) => {
      state.hasNewMessage = true;
    },
    receivedNewMessage: (state) => {
      state.hasNewMessage = false;
    },
  },
  extraReducers: (builder) => {
    // 當fetchUser的非同步action fulfilled，將資料塞進state裡面
    builder.addCase(fetchUser.fulfilled, (state, { payload }) => {
      if (payload) {
        console.log({ payload });
        state.auth = payload[0];
        state.userGroup = payload[1]?.data[0];
      }
    });
    builder.addCase(fetchAdmin.fulfilled, (state, { payload }) => {
      state.adminUserGroup = payload[0].data[0];
    });
  },
});
export const { getNewMessage, receivedNewMessage } = userSlice.actions;
export default userSlice.reducer;
